import { render, staticRenderFns } from "./EventPackage.vue?vue&type=template&id=ec0c9dbe&scoped=true"
import script from "./EventPackage.vue?vue&type=script&lang=js"
export * from "./EventPackage.vue?vue&type=script&lang=js"
import style0 from "./EventPackage.vue?vue&type=style&index=0&id=ec0c9dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0c9dbe",
  null
  
)

export default component.exports